import { observer } from "mobx-react";

const ICSPROJECT_URL = "/api/project/";
const SCENARIO_URL = "/scenarios";
const ADDITION_URL = "/api/analysis/icsmodeladdition/";

// Component
const AdditionTab = observer(() => {
  return <></>;
  /*
  const appStore = useAppStore();
  const [openTable, setOpenTable] = useState(false);
  const { id } = useParams();
  const [scenarioData, setScenarioData] = useState([]);
  const [scenario, setScenario] = useState("");
  const [additionGridData, setAdditionGridData] = useState([]);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [selected, setSelected] = useState([]);

  const projectModelId = undefined;
  const modelId = undefined;

  const handleClickOpenTable = () => {
    setOpenTable(true);
  };

  const handleScenarioChange = (event: any) => {
    setScenario(event.target.value);
    getAdditionData(event.target.value);
  };

  useEffect(() => {
    async function getScenarios() {
      try {
        const resScemario = await axios.get(`${ICSPROJECT_URL}${projectModelId}${SCENARIO_URL}`);
        if (resScemario.status === 200) {
          setScenarioData(resScemario.data);
          const a = resScemario.data.at(0);
          console.log(a);
          console.log(resScemario);
          getAdditionData(a.icsScenarioId);
          setScenario(a.icsScenarioId);
        }
      } catch (err) { }
    }
    getScenarios();
  }, []);

  async function removeAdditions(values: any) {
    try {
      const resRemoveAddition = await axios.delete(`${ADDITION_URL}${modelId}?projectId=${id}`, {
        data: values,
      });
      if (resRemoveAddition.status === 204) {
        handleCloseConfirm();
        getAdditionData(scenario);
      }
    } catch (err) { }
  }

  async function getAdditionData(scenarioId: string) {
    try {
      const addRes = await axios.get(ADDITION_URL + modelId + `/${scenarioId}`);
      if (addRes.status === 200) {
        setAdditionGridData(addRes.data);
      }
    } catch (err) { }
  }

  function handleRemoveAddition(val: any) {
    console.log(val);
    setSelected(val);
  }
  function removeAddition() {
    removeAdditions(selected);
  }
  const handleCloseConfirm = () => {
    setOpenConfirmDelete(false);
  };
  const handleCloseOpen = () => {
    setOpenConfirmDelete(true);
  };

  const handleCloseTable = (val: any) => {
    setOpenTable(false);
    if (val) {
      getAdditionData(scenario);
    }
  };
  return (
    <Box mt={1} sx={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
      <Stack direction={"row"} spacing={2}>
        <FormControl fullWidth>
          <InputLabel id="scenario-label">Scenarios</InputLabel>
          <Select
            labelId="scenario-label"
            id="senario-id"
            value={appStore.scenario || ""}
            label="Scenarios"
            onChange={handleScenarioChange}
          >
            {scenarioData.map((scenario: any) => (
              <MenuItem key={scenario.ccenarioId} value={scenario}>
                {scenario.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      <Box mt={2} sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        {appStore.scenario && appStore.model &&
          <>
            <AdditionGrid
              scenario={scenario}
              modelId={appStore.model?.modelId}
              projectId={id}
              data={additionGridData}
              selectedId={(val: any) => handleRemoveAddition(val)}
            />
            <Grid container spacing={2} sx={{ justifyContent: "end" }}>
              <Grid>
                <Button onClick={handleClickOpenTable} variant="contained">
                  Add Element
                </Button>
              </Grid>
              <Grid>
                <Button disabled={selected.length === 0} onClick={handleCloseOpen} variant="outlined">
                  Remove Element
                </Button>
              </Grid>
            </Grid>
          </>
        }
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={openTable}
          onClose={handleCloseTable}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {"Add Non-Modeled Material"}
            <IconButton onClick={handleCloseTable}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <AdditionModalTable
              isDialogOpened={openTable}
              handleCloseDialog={(val: any) => handleCloseTable(val)}
              scenario={scenario}
              modelId={appStore.model?.modelId}
              projectId={id}
            />
          </DialogContent>
        </Dialog>
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={openConfirmDelete}
          onClose={handleCloseConfirm}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {"Remove Additions"}
            <IconButton onClick={handleCloseConfirm}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Do you want to remove the {selected.length} selected {selected.length > 1 ? "additions" : "addition"} ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={removeAddition} autoFocus>
              Remove
            </Button>
            <Button onClick={handleCloseConfirm}>No</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
  */
});

export default AdditionTab;
